import React from "react";
import { parseISO } from "date-fns";
import { FiltersTypes } from "@common/types/filters/general";
import { getDateRangeLabel } from "@helpers/date";

interface Props {
    filters: FiltersTypes;
}

export const DocumentPeriodFilterLabel: React.FC<Props> = ({ filters }) => {
    const start = filters.periodStart
        ? parseISO(filters.periodStart)
        : undefined;
    const end = filters.periodEnd ? parseISO(filters.periodEnd) : undefined;
    return <>{getDateRangeLabel(start, end)}</>;
};
